import * as fromDatatype from "../datatype-library/index";

export interface bl_inv_stock_conversion_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  job_order_hdr_guid: fromDatatype.GuidDataFieldInterface;
  process_guid: fromDatatype.GuidDataFieldInterface;
  machine_guid: fromDatatype.GuidDataFieldInterface;
  duration: fromDatatype.NumericDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  location_guid: fromDatatype.GuidDataFieldInterface;
  process_status: fromDatatype.VarcharDatatypeInterface;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  end_date: fromDatatype.TimestampTzDatatypeInterface;
  posting_inventory: fromDatatype.VarcharDatatypeInterface;
  posting_journal: fromDatatype.VarcharDatatypeInterface;
  posting_running_no: fromDatatype.VarcharDatatypeInterface;
  process_type_code: fromDatatype.VarcharDatatypeInterface;
  posting_status: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
}

export class bl_inv_stock_conversion_hdr_RowClass
  implements bl_inv_stock_conversion_hdr_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  job_order_hdr_guid: fromDatatype.GuidDataFieldInterface;
  process_guid: fromDatatype.GuidDataFieldInterface;
  machine_guid: fromDatatype.GuidDataFieldInterface;
  duration: fromDatatype.NumericDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  location_guid: fromDatatype.GuidDataFieldInterface;
  process_status: fromDatatype.VarcharDatatypeInterface;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  end_date: fromDatatype.TimestampTzDatatypeInterface;
  posting_inventory: fromDatatype.VarcharDatatypeInterface;
  posting_journal: fromDatatype.VarcharDatatypeInterface;
  posting_running_no: fromDatatype.VarcharDatatypeInterface;
  process_type_code: fromDatatype.VarcharDatatypeInterface;
  posting_status: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
}
